export const ReminderTypeEnum = {
  Email: {
    key: 1,
    value: 'Email',
  },
  Sms: {
    key: 2,
    value: 'Sms',
  },
  LineManager: {
    key: 3,
    value: 'Notification',
  }
};
